export default "__VITE_ASSET__DO_ekEAO__"